import { useQuery } from '@tanstack/react-query';
import { sireAncestorKeys } from '../queries/AlpacaQueries';
import AncestryApi from '../apis/ancestry_api';
import SireAncestryDisplay from './SireAncestryDisplay/SireAncestryDisplay';
import { useUserDetails } from '../helpers/UserContext';
import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import UpdateSireAncestryDisplay from './UpdateSireAncestryDisplay/UpdateSireAncestryDisplay';

export default function SireAncestry({ alpacaId }: { alpacaId: number }) {
  const [isEdit, setIsEdit] = useState(false);
  const [userDetails] = useUserDetails();
  const { data: sireAncestry = {} } = useQuery({
    queryKey: sireAncestorKeys.for(alpacaId),
    queryFn: () => AncestryApi.getSireAncestry(alpacaId),
  });
  return (
    <div className='mb-6 w-full pt-4'>
      <div className='mb-2 flex items-center justify-start'>
        <h3 id='sire-ancestry' className='m-0'>
          Sire Ancestry{' '}
        </h3>
        <button
          name='edit'
          className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
          onClick={() => setIsEdit(!isEdit)}
        >
          {' '}
          <div className='flex items-center gap-2'>
            <FaEdit /> Edit
          </div>
        </button>
      </div>
      {isEdit ? (
        <UpdateSireAncestryDisplay
          close={() => setIsEdit(false)}
          sireAncestry={
            (Object.keys(sireAncestry)?.length ?? 0) > 0
              ? { ...sireAncestry }
              : {
                  alpacaId: alpacaId,
                  applicationUserId: userDetails?.userId,
                }
          }
        />
      ) : (
        <SireAncestryDisplay sireAncestry={sireAncestry} />
      )}
    </div>
  );
}
